import React, { useEffect } from "react";
import styled from "styled-components";
import playSound from "@/sound";
import {
  correctSound,
  incorrectSound,
  clickSound,
  blockTouch,
  sleep,
} from "@stores/vars";
import anime from "animejs/lib/anime.es.js";
import { useState } from "react";
import { useRef } from "react";

const Wrap = styled.div`
  position: relative;
  height: 1200px;
  opacity: 0;
`;

const Card = styled.div`
  position: absolute;
  width: 622px;
  height: 219px;
  top: 358px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 120px;
  background-color: #fff;
  box-shadow: 2px 2px 0px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  &:after {
    content: "";
    display: inline-block;
    width: 65px;
    height: 118px;
    background: url(${require("@assets/img/icon_q3.png")}) no-repeat;
  }
`;

const Speaker = styled.button`
  position: absolute;
  width: 233px;
  height: 233px;
  top: 344px;
  right: 363px;
  border-radius: 50%;
  background: url(${require("@assets/img/icon_speaker.png")}) no-repeat;
  box-shadow: 2px 2px 0px 4px rgba(0, 0, 0, 0.1);
`;

const ButtonWrap = styled.div`
  position: absolute;
  left: 50%;
  bottom: 115px;
  transform: translateX(-50%);
  padding: 45px 120px;
  border-radius: 120px;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  gap: 45px;
  align-items: center;
  font-size: 50px;
  justify-content: center;
  white-space: nowrap;
  &::before {
    content: "";
    position: absolute;
    width: 100px;
    height: 105px;
    top: -50px;
    left: 0px;
    background: url(${require("@assets/img/icon_q.png")}) no-repeat;
    background-size: 100%;
  }
  &::after {
    content: "";
    position: absolute;
    width: 99px;
    height: 108px;
    top: -10px;
    right: -20px;
    background: url(${require("@assets/img/icon_q2.png")}) no-repeat;
    background-size: 100%;
  }
`;

const PronounceBtn = styled.button`
  padding: 34px 98px;
  color: #fff;
  box-sizing: border-box;
  border-radius: 90px;
  border: 15px solid #fff;
  font-family: Noto Sans SC;
  &:first-child {
    background-color: #16c8b1;
  }
  &:last-child {
    background-color: #ffb400;
  }
`;
const FeedBack = styled.div`
  position: absolute;
  left: 50%;
  top: 300px;
  margin-left: -166px;
  display: none;
  z-index: 10;
  &.answer-X {
    width: 332px;
    height: 332px;

    background: url(${require("@assets/img/activity_answer_x.png")}) no-repeat;
  }
  &.answer-O {
    width: 332px;
    height: 332px;
    background: url(${require("@assets/img/activity_answer_o.png")}) no-repeat;
  }
`;

const WordText = styled.div`
  position: absolute;
  left: 30px;
  top: 12px;
  width: 90%;
  height: 90%;
  background-color: #fff;
  color: #000;
  font-size: 75px;
  font-family: Noto Sans SC;
  border-radius: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ActivityType3 = ({ data, onSuccess }) => {
  const [selectText, setText] = useState(null);
  const spkRef = useRef(null);
  const btnWrapRef = useRef(null);

  const onSoundPlay = () => {
    const soundUrl = data.sound;
    playSound.word(soundUrl);
    anime({
      targets: spkRef.current,
      scale: [0.5, 1],
      opacity: [0, 1],
    });
  };

  const onClickButton = async (isCorrect, txt) => {
    playSound.effect(clickSound);
    blockTouch();
    setText(txt);
    await sleep(1000);
    const feedback = document.querySelector(
      isCorrect === true ? ".answer-O" : ".answer-X"
    );
    feedback.style.display = "block";

    if (isCorrect === true) {
      playSound.effect(correctSound);
    } else {
      playSound.effect(incorrectSound);
    }

    anime({
      targets: feedback,
      scale: [0, 1],
      opacity: [0, 1],
    });

    await sleep(1000);
    feedback.style.display = "none";

    if (isCorrect) {
      await playSound.word(data.sound);
      await sleep(1000);
      setText(null);
      onSuccess();
      // blockTouch(false);
    } else {
      setText(null);
      await sleep(500);
      blockTouch(false);
    }
  };

  useEffect(() => {
    if (selectText) {
      anime({
        targets: document.querySelector("#sWord"),
        opacity: [0, 1],
        easing: "linear",
        duration: 400,
      });
    } else {
      document.querySelector(".answer-O").style.display = "none";
      document.querySelector(".answer-X").style.display = "none";
    }
  }, [selectText]);

  useEffect(() => {
    btnWrapRef.current.style.opacity = 0.5;
    btnWrapRef.current.style.pointerEvents = "none";
    spkRef.current.style.pointerEvents = "none";
    anime({
      targets: document.querySelector(".t3"),
      translateY: [-100, 0],
      opacity: [0, 1],
      easing: "easeOutBack",
      durtaion: 200,
    });

    playSound
      .word(require("@data/assets/_static/sounds/activity3.mp3"))
      .then(() => {
        onSoundPlay();
        anime({
          targets: btnWrapRef.current,
          opacity: 1,
          easing: "linear",
          durtaion: 200,
        });
        btnWrapRef.current.style.pointerEvents = "";
        spkRef.current.style.pointerEvents = "";
      });
    return () => {
      playSound.wordStop();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <Wrap className="t3">
      {/* {selectImg && <img src={selectImg} alt="" id="sCard" />} */}
      <Card>{selectText && <WordText id="sWord">{selectText}</WordText>}</Card>
      <Speaker type="button" onClick={onSoundPlay} ref={spkRef} />
      <ButtonWrap ref={btnWrapRef}>
        <PronounceBtn
          type="button"
          onClick={() => onClickButton(data.answer[0][1], data.answer[0][0])}
        >
          {data.answer[0][0]}
        </PronounceBtn>
        <PronounceBtn
          type="button"
          onClick={() => onClickButton(data.answer[1][1], data.answer[1][0])}
        >
          {data.answer[1][0]}
        </PronounceBtn>
      </ButtonWrap>
      <FeedBack className="answer-X" />
      <FeedBack className="answer-O" />
    </Wrap>
  );
};

export default ActivityType3;
